require('UserInfo')
.define('AuctionFavorites',function(imports){
  var UserInfo = imports.UserInfo;
  var AuctionPage = null; //= imports.AuctionPage;

  function on_favorites_page() {
    return $('section.cw-auction').hasClass('cw-favorites');
  }

  function setup(auction_page) {
    AuctionPage = auction_page;
    if (AuctionPage.on_page("list")) {
      AuctionPage.add_listener(handle_auction_list_page_event);
    }
    AuctionPage.add_listener(handle_auction_page_event);

    updateCsrfToken();
    activate_favorites(auction_page);
  }

  function activate_favorites(auction_page) {
    AuctionPage = auction_page;
    if (AuctionPage.on_page("list")) {
      if (UserInfo.ready() && UserInfo.is_logged_in()) {
        AuctionPage.list_update_favorites(UserInfo.data());
      }
    } else if (UserInfo.ready() && UserInfo.is_logged_in()) {
      list_update_favorites(UserInfo.data());
    }

    // Check if there were favorites stored when the user was not logged in
    if (cw_store.enabled) {
      var lot_ids = cw_store.get_session('temporary_favorites');
      if (lot_ids) {
        lot_ids = lot_ids.split(',');
        for (var i in lot_ids) {
          var lot = $('#l' + lot_ids[i] + '_detail, #l' + lot_ids[i] + '_list');
          if (lot.length > 0) {
            if (UserInfo.ready() && UserInfo.is_logged_in()) {
              save_favorite(lot, lot_ids[i]);
            } else {
              lot.addClass("favorite");
            }
          }
        }
        if (UserInfo.ready() && UserInfo.is_logged_in()) {
          // Reset temporary favorites when logged in
          cw_store.remove_session('temporary_favorites');
        }
      }
    }

    var lot_nr_favorites = AuctionPage.on_page("list");
    $favs = $("div.cw_favourite:not(.activated)");
    $favs.each(function(){
      var $fav_instance = $(this);
      if (lot_nr_favorites) {
        $fav_instance.find('span.cw-favourite-text[data-lot_nr_favorites!=0]').removeClass('hide');
      }
      $fav_instance.addClass('activated').find('a').on('click', function(evt){
        evt.stopPropagation();
        evt.preventDefault();
        var lot_id = $(this.parentNode).data("lot_id");
        var lot = $('#'+$(this.parentNode).data("target"));

        var url = '/buyer/api/v1/users/me/interests/lots/' + lot_id;
        var $favs_lot = $( "#favs_lot_" +  lot_id);

        // Save favourites when logged in
        if (lot.hasClass("favorite")) {
          lot.removeClass("favorite");
          if (on_favorites_page()) {
            update_favorites_list(lot);
          }

          // EXPERIMENT OR-239
          if (!isLoggedIn() && cw_store.enabled) {
            store_temporary_favorites(lot, lot_id, 'remove');
          } else {
            $.ajax({
              url: url,
              type: 'DELETE',
              success: function (data) {
                updateAmount(data, lot_id, -1);
              }
            });
          }

          track_favorite_click(lot_id, false);
        } else {
          // EXPERIMENT OR-239
          if (!isLoggedIn() && cw_store.enabled) {
            setTimeout(function() {
              window.inlineHints.openHint($('#favourite_not_logged_in'));
            }, 500);

            store_temporary_favorites(lot, lot_id, 'add');
          } else {
            save_favorite(lot, lot_id);
          }

          track_favorite_click(lot_id, true);
        }
        return false;
      });
    });
  }

  function save_favorite(lot, lot_id) {
    // Save favourites through ajax
    lot.addClass("favorite");
    $.post("/buyer/api/v1/users/me/interests/lots", { "lot_id": lot_id }, function(data){
      updateAmount(data, lot_id, 1);
      if (typeof(AB) != 'undefined') {
        AB.conversion('mark_as_favorite');
        if ($('body').hasClass('cw-exceptional_lots_page')) {
          AB.conversion('favorite_exceptional_lots_mark_as_favorite');
        }
      }
    });
  }

  function track_favorite_click(lot_id, actionFavorite) {
    if (Object.prototype.hasOwnProperty.call(window, 'dataLayer')) {
      window.dataLayer.push({
        event: 'ga-event',
        eventCategory: 'Favorite events',
        eventAction: actionFavorite ? 'Favorite lot' : 'Unfavorite lot',
        eventLabel: lot_id,
        lot_id: lot_id,
      });
    }
  }

  function activate_favorites_async(auction_page) {
    if (!(UserInfo.ready() && UserInfo.is_logged_in())) {
      return;
    }

    var new_lots = $('.cw_favourite[data-lot_id]:not(".js-favorites-loaded")');
    new_lots.addClass('js-favorites-loaded');
    var new_lot_ids = new_lots.map(function(){
      return $(this).data('lot_id');
    }).get().join(',');
    params = { search_results_lot_ids : new_lot_ids };
    $.get("/veilingen/user_info", params, function(data) {
      AuctionPage.list_update_favorites(data);
      activate_favorites(auction_page);
    });
  }

  function get_lot_in_list(id) {
    return $('#l'+id+"_list");
  }

  function list_update_favorites(data) {
    $.each(data.favorites, function (i, lot_id) {
      get_lot_in_list(lot_id).addClass("favorite");
    });
  }

  // STILL NEEDED update auction status class
  // update open lots counter
  function handle_auction_list_page_event(event) {
    if (event.name == "deactivate_lot") {
      update_favorites_list(event.target)
    }
    if (event.name == "close_lot") {
      update_lot_count()
    }
  }

  function handle_auction_page_event(event) {
    if (event.name == "current_user_bid") {

      set_favorite_class(event.lot);
    }
  }

  function set_favorite_class(lot) {
    if (!lot.hasClass('favorite')) {
      lot.addClass("favorite");

      var counter = $('.cw-favourite-amount:visible', lot);
      if (counter.length != 0) {
        var count = parseInt(counter.html(), 10);
        if (!isNaN(count)) {
          updateAmount( { count : count });
        }
      }
    }
  }

  /**
    update the lot list on the favorites page if a favorite lot is hidden or removed.

    params - changed_lot: lot that has been hidden because it is closed or removed from favorites.
  */
  function update_favorites_list(changed_lot) {
    update_favorites_status();
    update_lot_count();
  }

  function favorites_status_class() {
    var number_of_favorites = $(".cw-item-auctionlot", "#lot_list").length;
    var number_of_closed_lots = AuctionPage.number_of_closed_lots();

    //opens_soon is never returned by this function because it is only
    //triggered when lots are closed.
    if (number_of_closed_lots == number_of_favorites) {
      return "cw-auction-status-closed";
    }
    else if (number_of_closed_lots > 0 && number_of_closed_lots < number_of_favorites) {
      return 'cw-auction-status-closing_now';
    }
    else {
      // this one should also never occur.
      return "cw-auction-status-open_now";
    }
  }


  function update_favorites_status() {
    var el = $("section.cw-auction.cw-favorites");
    el.removeClass("cw-auction-status-opens_soon");
    el.removeClass("cw-auction-status-open_now");
    el.removeClass("cw-auction-status-closing_now");
    el.removeClass("cw-auction-status-closed");
    el.addClass(favorites_status_class());
  }

  function update_lot_count() {
    var number_of_favorites = $(".cw-item-auctionlot.favorite", "#lot_list").length;
    var number_of_closed_lots = AuctionPage.number_of_closed_lots();
    $("span.lotcount",".cw-auction-status").text(number_of_favorites - number_of_closed_lots)
  }

  function updateAmount(data, lot_id, incr) {
    // select lot in auction or lot detail page
    // data.count is the real amount of favs, but we show the visible amount +/- 1
    // real amount may have changed after initial page load...
    var $lot = $("#l" + lot_id + "_detail").first();
    if ($lot.length < 1) {
      $lot = $("[data-lot_id='" + lot_id + "']").first();
    }
    var $counter = $lot.find("span.cw-favourite-text.cw-favourite-amount").first();
    if ($counter.length > 0) {
      var nr_fav = $counter.data('lot_nr_favorites');
      if (incr > 0 && nr_fav == 0) {
        $counter.removeClass('hide');
      } else if (nr_fav == 1 && incr < 0) {
        $counter.addClass('hide');
      }
      $counter.data('lot_nr_favorites', nr_fav+incr);
      $counter.html(nr_fav+incr);
    }
  }

  function updateCsrfToken() {
    var update_token = false;
    var cached_pages = ['cw-exceptional_lots_page'];

    $.each(cached_pages, function(idx, css_class) {
      if ($('body').hasClass(css_class)) {
        update_token = true;
      }
    });

    if (update_token && window.UserInfo !== undefined && UserInfo.data() && UserInfo.data().csrf_token !== undefined) {
      var csrf_token = UserInfo.data().csrf_token;
      $('meta[name="csrf-token"]').attr('content', csrf_token);
    }
  }

  function logRecommendationsToHoneybadger(context) {
    if (typeof Honeybadger === 'undefined') {
      return;
    }

    Honeybadger.notify({
      message: 'Invalid response from /lots/recommendations',
      name: 'InvalidResponse',
      fingerprint: 'lots_recommendations_invalid',
      context: context
    });
  }

  return {
    setup: setup,
    activate_favorites_async: activate_favorites_async,
    on_favorites_page: on_favorites_page
  };

  // EXPERIMENT OR-239
   function store_temporary_favorites(lot, lot_id, action) {
    // Store favorites in session (when not logged in)
    var stored_favs = cw_store.get_session('temporary_favorites');
    if (stored_favs) {
      stored_favs = stored_favs.split(',');
    } else {
      stored_favs = [];
    }
    lot_id += ''; // Make it a string
    if (action == 'add') {
      lot.addClass('favorite');
      stored_favs[stored_favs.length] = lot_id;
    } else if (action == 'remove') {
      lot.removeClass('favorite');
      var index = $.inArray(lot_id, stored_favs);
      if (index > -1) {
        stored_favs.splice(index, 1);
      }
    }
    cw_store.set_session('temporary_favorites', stored_favs.join(','));
  }

  function isLoggedIn () {
    return UserInfo.ready() && UserInfo.is_logged_in();
  }
});
